export enum Panel {
  ProjectDetails = 'ProjectDetails',
  Buildings = 'Buildings',
  Cases = 'Cases',
  Sections = 'Sections',
  SmartRequests = 'SmartRequests',
  Deliverables = 'Deliverables'
}
